/**
 * Runtime configuration from Vite env variables (see .env.example).
 * Ads are OFF unless explicitly enabled AND a real publisher ID is provided.
 */
const env = import.meta.env;

const client = (env.VITE_ADSENSE_CLIENT ?? '').trim();
const validClient = /^ca-pub-\d{10,20}$/.test(client);

export const adsConfig = {
  enabled: env.VITE_ADS_ENABLED === 'true' && validClient,
  client: validClient ? client : '',
  slots: {
    home: (env.VITE_ADSENSE_SLOT_HOME ?? '').trim(),
    library: (env.VITE_ADSENSE_SLOT_LIBRARY ?? '').trim(),
    /** Below a finished export only — never while editing or exporting. */
    export: (env.VITE_ADSENSE_SLOT_EXPORT ?? '').trim(),
  },
  /** Show dashed placeholders where ads would appear (development only). */
  showPlaceholders: env.DEV || env.VITE_ADS_PLACEHOLDERS === 'true',
};
